import { useState, useEffect } from 'react';
import FeaturesNav from './components/FeaturesNav';
import FeaturesHero from './components/FeaturesHero';
import FeatureFlightScoring from './components/FeatureFlightScoring';
import FeatureRadioTranscription from './components/FeatureRadioTranscription';
import FeatureIFRHowItWorks from './components/FeatureIFRHowItWorks';
import FeatureTryItLive from './components/FeatureTryItLive';
import FeaturePatternAnalysis from './components/FeaturePatternAnalysis';
import FeatureCoachingInsights from './components/FeatureCoachingInsights';
import FeatureProgressTracking from './components/FeatureProgressTracking';
import FeatureCockpitSupport from './components/FeatureCockpitSupport';
import FeaturePreflightInspection from './components/FeaturePreflightInspection';
import FeaturesCTA from './components/FeaturesCTA';
import EarlyAccessSection from '../home/components/EarlyAccessSection';
import Footer from '../home/components/Footer';
import BackToTopButton from '../../components/feature/BackToTopButton';

export default function FeaturesPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A1628] text-white">
      <FeaturesNav scrolled={scrolled} />
      <FeaturesHero />
      <FeatureFlightScoring />
      <FeatureRadioTranscription />
      <FeatureIFRHowItWorks />
      <FeatureTryItLive />
      <FeaturePatternAnalysis />
      <FeatureCoachingInsights />
      <FeatureProgressTracking />
      <FeatureCockpitSupport />
      <FeaturePreflightInspection />
      <EarlyAccessSection />
      <FeaturesCTA />
      <Footer />
      <BackToTopButton />
    </div>
  );
}
